import { ImWhatsapp } from 'react-icons/im'

import './style.scss'

export function IconWhats() {
    return (
        <div className="iconWhats">
            <ImWhatsapp />
        </div>
    )
}